/* Min difference between two metrics in order 
for one to be considered higher or lower than the other. */
export const MIN_DELTA = 1.0
